
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Boatclubroadtomumbai() {



    const cardData =
    {
        keyword: 'Boat Club Road to Mumbai Cab',
        heading: 'Skyline Cabs: Boat Club Road to Mumbai Cab',
        headingDescription: 'Skyline Cabs provides premium Boat Club Road to Mumbai Cab services for a comfortable and luxurious travel experience. Whether you are traveling for business meetings, a family trip, or airport transfers, our well-maintained fleet and professional drivers ensure a smooth, timely, and safe journey. With competitive fares and top-rated service, Skyline Cabs makes your journey from Boat Club Road to Mumbai stress-free and reliable. Book your cab today and travel with ease.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Boat Club Road to Mumbai Cab Price",
      "description": "Skyline Cabs offers affordable and transparent pricing for cab services from Boat Club Road to Mumbai. Whether you're traveling for business or leisure, we provide timely pickup and well-maintained vehicles for a stress-free journey."
    },
    {
      "name": "Boat Club Road to Mumbai Innova Cab",
      "description": "Book a premium Innova with Skyline Cabs from Boat Club Road to Mumbai for a spacious and comfortable travel experience. Ideal for families and small groups, the Innova ensures luxury with ample legroom and luggage space."
    },
    {
      "name": "Cab Service in Pune - Boat Club Road",
      "description": "Skyline Cabs provides prompt and professional cab services around Boat Club Road in Pune. Our fleet includes sedans, SUVs, and luxury vehicles for airport drops, city travel, or outstation trips to Mumbai and beyond."
    },
    {
      "name": "Cheapest Cab Service in Pune - Boat Club Road",
      "description": "Looking for budget-friendly rides from Boat Club Road? Skyline Cabs offers economical and reliable taxi options without compromising on comfort or safety. Book your ride to Mumbai or anywhere across Pune today."
    },
    {
      "name": "Boat Club Road to Dadar Cab Service",
      "description": "Skyline Cabs provides smooth and punctual cab services from Boat Club Road to Dadar. Choose from a wide range of vehicles including Innova and Ertiga for a relaxing ride to the heart of Mumbai."
    },
    {
      "name": "Sangamwadi to Mumbai Cabs",
      "description": "Skyline Cabs operates reliable cab services from Sangamwadi to Mumbai. Enjoy seamless travel with experienced drivers, clean vehicles, and a choice of economy and premium options."
    },
    {
      "name": "Sangamwadi to Mumbai Airport Cabs",
      "description": "Travel to Mumbai Airport from Sangamwadi with Skyline Cabs. Our airport transfer services offer timely pickups and comfortable rides in sedans, Ertiga, or Innova vehicles."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Skyline Cabs is rated as one of the best cab services for Pune to Mumbai travel. We offer 24/7 booking, experienced drivers, sanitized cars, and both one-way and round-trip options."
    },
    {
      "name": "Yerwada to Mumbai Cab Service",
      "description": "Get professional cab service from Yerwada to Mumbai with Skyline Cabs. Our well-maintained vehicles and trained chauffeurs ensure a comfortable and timely journey, ideal for personal or business travel."
    },
    {
      "name": "Cab Service in Yerwada Pune",
      "description": "Skyline Cabs offers top-rated taxi services in Yerwada for local and outstation travel. Choose from multiple vehicle options including sedans and SUVs for a safe and hassle-free ride."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs provides full-service taxi operations in Pune. Whether you're heading to Mumbai, the airport, or exploring Pune, we ensure quality service, transparent pricing, and professional drivers."
    },
    {
      "name": "Cab Service in Bund Garden Pune",
      "description": "Skyline Cabs serves Bund Garden with reliable taxi services for local and intercity travel. We offer on-time pickups, professional drivers, and a range of vehicle options for every budget."
    },
    {
      "name": "Bund Garden to Mumbai Cab",
      "description": "Skyline Cabs offers cab services from Bund Garden to Mumbai for one-way and round-trip bookings. Enjoy smooth rides in sedans, SUVs, or luxury vehicles with experienced drivers."
    },
    {
      "name": "Boat Club Road Taxi Service",
      "description": "Skyline Cabs provides dependable taxi services on Boat Club Road for airport transfers, intercity travel to Mumbai, or local Pune trips. Enjoy flexible booking, sanitized cars, and professional service."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers seamless cab services from Pune to Mumbai Airport. With round-the-clock availability and vehicle options like Innova and Ertiga, we make your airport transfer smooth and stress-free."
    },
    {
      "name": "Pune Mumbai Cab",
      "description": "Skyline Cabs specializes in Pune to Mumbai taxi travel. Whether you’re looking for a luxury ride or a budget option, our fleet ensures safety, comfort, and punctuality every time."
    }
  ],
  "tableData": [
    ["Boat Club Road to Mumbai Cab Price", "Boat Club Road to Mumbai Innova Cab"],
    ["Cab Service in Pune - Boat Club Road", "Cheapest Cab Service in Pune - Boat Club Road"],
    ["Boat Club Road to Dadar Cab Service", "Sangamwadi to Mumbai Cabs"],
    ["Sangamwadi to Mumbai Airport Cabs", "Best Cab Service Pune to Mumbai"],
    ["Yerwada to Mumbai Cab Service", "Cab Service in Yerwada Pune"],
    ["Cab Service in Pune", "Cab Service in Bund Garden Pune"],
    ["Bund Garden to Mumbai Cab", "Boat Club Road Taxi Service"],
    ["Pune to Mumbai Airport Cab", "Pune Mumbai Cab"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Boat Club Road to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and punctual cab services from Boat Club Road to Mumbai. Whether you're planning a business meeting, catching a flight, or heading for a leisure trip, we ensure timely pickups and a smooth journey every time."
    },
    {
        "WhyChooseheading": "Premium Comfort for a Relaxing Journey",
        "WhyChoosedescription": "Travel in style and comfort from Boat Club Road to Mumbai in our clean, air-conditioned vehicles. Our fleet includes sedans, SUVs, and luxury cars that are perfect for a relaxing long-distance trip, with plush seating and ample space for luggage."
    },
    {
        "WhyChooseheading": "Professional and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are experienced, well-trained, and courteous. They know the Boat Club Road to Mumbai route well, ensuring a safe, comfortable, and efficient drive. Whether you're traveling solo or with family, you're in capable hands."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
        "WhyChoosedescription": "Enjoy competitive and transparent fares for your trip. Skyline Cabs provides upfront pricing with no hidden charges, so you know exactly what you’re paying for. Get great value without compromising on service quality."
    },
    {
        "WhyChooseheading": "Available 24/7 for Flexible Travel Plans",
        "WhyChoosedescription": "Our cab service from Boat Club Road to Mumbai operates 24/7, allowing you to travel whenever it's most convenient for you. Whether it's an early morning airport drop or a late-night ride back, we’re always ready to serve you."
    },
    {
        "WhyChooseheading": "Vehicle Options to Suit Your Needs",
        "WhyChoosedescription": "From solo travelers to groups, we have the right car for every type of traveler. Choose from economy sedans, spacious SUVs, or luxury models depending on your comfort and budget preferences."
    },
    {
        "WhyChooseheading": "Fast and Easy Online Booking",
        "WhyChoosedescription": "Booking a cab from Boat Club Road to Mumbai is fast and convenient. Use our mobile app or website for instant reservations, live cab tracking, and digital payment options, all designed to make your experience seamless."
    },
    {
        "WhyChooseheading": "Safe and Secure Ride Every Time",
        "WhyChoosedescription": "All Skyline Cabs are GPS-enabled for real-time tracking and are driven by background-verified professionals. Your safety and peace of mind are our top priorities during every ride from Boat Club Road to Mumbai."
    }
]


















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Boat Club Road to Mumbai with Skyline Cabs?',
            answer:
                'Booking is quick and easy through our website or mobile app. Just enter Boat Club Road as your pickup point and Mumbai as your destination. Choose your preferred vehicle and confirm your trip in minutes. You can also call our 24/7 customer support for help.',
        },
        {
            id: 2,
            question: 'What types of cabs are available for Boat Club Road to Mumbai?',
            answer:
                'We offer a wide range of vehicles including sedans, SUVs, Ertiga, Innova Crysta, and luxury cars for our Boat Club Road clients. Choose a ride that matches your style and comfort level.',
        },
        {
            id: 3,
            question: 'Is the pricing fixed for Boat Club Road to Mumbai cab service?',
            answer:
                'Yes, Skyline Cabs provides fixed and transparent pricing. All fares include tolls, driver charges, and taxes. You’ll see the final price before confirming your booking — no hidden charges.',
        },
        {
            id: 4,
            question: 'Do you offer round-trip options from Boat Club Road to Mumbai?',
            answer:
                'Absolutely. You can book both one-way and round-trip rides. If you know your return details, just add them during booking, and we’ll ensure a smooth round journey.',
        },
        {
            id: 5,
            question: 'How long does it take to reach Mumbai from Boat Club Road?',
            answer:
                'It usually takes around 3.5 to 4 hours depending on traffic. Our experienced drivers ensure timely and safe arrivals using the best possible routes.',
        },
        {
            id: 6,
            question: 'Can I book a cab from Boat Club Road to Mumbai Airport?',
            answer:
                'Yes! We offer reliable airport transfers from Boat Club Road to both Domestic and International terminals in Mumbai. Just enter your flight details for on-time drop-offs.',
        },
        {
            id: 7,
            question: 'Are the cabs sanitized and air-conditioned?',
            answer:
                'Yes, all our cabs are thoroughly cleaned, sanitized, and fully air-conditioned. We prioritize hygiene and passenger safety at every step.',
        },
        {
            id: 8,
            question: 'Are drivers professional and familiar with Boat Club Road?',
            answer:
                'Definitely. Our drivers are well-versed with Boat Club Road’s surroundings and are trained for long-distance routes like Mumbai. Expect professional conduct, punctuality, and smooth driving.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my booking if plans change?',
            answer:
                'Yes, we offer flexible cancellation and modification options. You can update or cancel your trip directly from the app, website, or by calling our support team.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs from Boat Club Road to Mumbai?',
            answer:
                'Skyline Cabs is known for its premium service, punctuality, clean vehicles, and professional drivers. We cater especially to clients from high-end areas like Boat Club Road, offering a smooth and luxurious intercity experience.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Kunal Rane",
            rating: 5,
            review: "I often travel for business, and booking from Boat Club Road to Mumbai with Skyline Cabs has always been smooth. Great drivers, very clean cars, and I always reach on time. Highly recommended for professionals."
        },
        {
            name: "Miss. Sanika Joshi",
            rating: 4,
            review: "I had a family trip planned from Boat Club Road to Mumbai. The Ertiga was perfect — spacious and neat. The driver was polite and helpful with our luggage. Would love Wi-Fi in the car next time, but overall very happy!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Boat Club Road to Mumbai Cabs",
  "image": "https://skylinecabs.com/assets/images/boat-club-road-to-mumbai-cab.jpg",
  "description": "Book Boat Club Road to Mumbai cabs with Skyline Cabs for a premium, safe, and comfortable travel experience. Choose from AC sedans or SUVs with verified drivers — available 24/7 for one-way or round-trip rides.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7265"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1400",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/boat-club-road-to-mumbai-cabs"
  }
};


      
      


    return (
        <div>

<Helmet>
  <title>Boat Club Road to Mumbai Cabs | Premium AC Taxi Service | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Boat Club Road to Mumbai cabs with Skyline Cabs for a premium, safe, and comfortable travel experience. Choose from AC sedans or SUVs with verified drivers — available 24/7 for one-way or round-trip rides." 
  />
  <meta 
    name="keywords" 
    content="Boat Club Road to Mumbai Cabs, Cab from Boat Club Road to Mumbai, One-Way Taxi Boat Club Road to Mumbai, Round Trip Cab Boat Club Road to Mumbai, AC Cab Boat Club Road to Mumbai, SUV Taxi Boat Club Road to Mumbai, Premium Taxi Boat Club Road Mumbai, Skyline Cabs Boat Club Road to Mumbai, 24/7 Cab Booking Boat Club Road to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/25.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Boatclubroadtomumbai;